import React from 'react';

const SalaryRegister = () => {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold">Salary Register</h2>
      <p className="text-sm text-gray-600">Salary register report views will be added here.</p>
    </div>
  );
};

export default SalaryRegister;
